<template>
  <div class="element card">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <!-- <div class="card-id">{{ data.id }}</div> -->
        <div class="flex-grow-1">
          <h5 class="card-title text-center">{{ titleField }}</h5>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- <p class="card-text">Description: {{ data.description }}</p> -->
      <p v-for="field in showFields" :key="field" class="card-text">
        <span class="text-secondary">{{ field }}:&nbsp;</span>
        <template v-if="field === 'License'">
          <a v-if="license.url" :href="license.url" target="_blank">{{ license.text }}</a>
          <span v-else>{{ license.text }}</span>
        </template>
        <template v-else-if="field === 'Source Location'">
          <a :href="data[catalogueFields[field]]" target="_blank">{{
            data[catalogueFields[field]]
          }}</a>
        </template>
        <span v-else-if="field === 'Picture'">
          <img
            class="picture"
            v-if="data[catalogueFields[field]] != ''"
            :src="data[catalogueFields[field]]"
            alt="Resource Type Picture"
          />
        </span>
        <span v-else-if="arrayFields.includes(field)">{{
          data[catalogueFields[field]].join(', ')
        }}</span>
        <span v-else>{{ data[catalogueFields[field]] }}</span>
      </p>
      <div class="element__actions d-flex justify-content-end">
        <button
          type="button"
          v-if="enableEdition"
          class="element__actions-edit btn btn-reset btn-sm"
          @click.prevent="$emit('openEditModal', data)"
        >
          <i class="icon icon-edit text-main"></i>
        </button>
        <button
          type="button"
          v-if="enableEdition"
          class="element__actions-delete btn btn-reset btn-sm"
          @click.prevent="$emit('openDeleteModal', data)"
        >
          <i class="icon icon-delete text-main"></i>
        </button>
      </div>
    </div>
    <div v-if="data.tags" class="card-footer element__tags">
      <p class="mb-0">
        <strong class="text-primary">Tags:&nbsp;</strong>
        <span v-for="(tag, idx) in data.tags" :key="idx">
          {{ tag }}
          <span v-if="idx + 1 < data.tags.length">|</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import helpers from '@/lib/helpers'
export default {
  name: 'element-card',
  props: {
    data: Object,
    displayedFields: Array,
    titleField: String,
    enableEdition: Boolean,
    arrayFields: Array,
    catalogueFields: Object,
  },
  computed: {
    showFields() {
      const excludeItems = ['Id', 'Name', 'Tags', 'Dataset']
      return this.displayedFields.filter((field) => !excludeItems.includes(field))
    },
    license() {
      return helpers.license(this.data.license)
    },
  },
  methods: {
    // Ya no hace falta getId, lo he implementado con catalogueFields mejor que se fija en
    // getId(label) {
    //   return helpers.getIdFromLabel(label)
    // },
  },
  mounted() {
    console.log(this.titleField)
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/globals';
.element.card {
  word-break: break-all;
  border-top: 8px solid $main;
  .card-header,
  .card-footer {
    background-color: #fff;
  }
  .card-header {
    border-bottom: 1px solid $white-ghost;
    &.selected-border-bottom {
      border-bottom: 8px solid $main;
    }
    h5.card-title {
      margin-bottom: 0 !important;
    }
    // .card-id {
    //   height: 30px;
    //   margin-right: 10px;
    //   border: 1px solid $main;
    //   padding: 4px 8px;
    //   display: flex;
    //   font-size: 14px;
    //   font-weight: bold;
    //   align-items: center;
    //   white-space: nowrap;
    //   position: relative;
    // }
    // .card-id::before {
    //   content: 'ID';
    //   position: absolute;
    //   top: 0;
    //   left: 1px;
    //   font-size: 7px;
    //   color: $main;
    // }
  }
  img {
    &.picture {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }
}
</style>
